export const REQUEST_WEEKEND_WORK_CREATE_PATH = "/requests/weekend-work/create";

export const REQUEST_WEEKEND_WORK_EDIT_PATH = "/requests/weekend-work/edit/:id";
